import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '@ui/dialog.tsx';
import { useTranslation } from 'react-i18next';
import type { FC } from 'react';
import { AddPerformanceForm } from './add-performance-form.tsx';

interface AddPerformanceDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: () => void;
  fixedCompany?: { id: number; uniqueCode: string; name: string };
}
// AddPerformanceDialog component
export const AddPerformanceDialog: FC<AddPerformanceDialogProps> = ({
  isOpen,
  onOpenChange,
  onSuccess,
  fixedCompany
}) => {
  const { t } = useTranslation();

  const handleSuccess = () => {
    onOpenChange(false);
    onSuccess?.();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="overflow-hidden p-0 max-w-2xl"
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <div className="p-14 max-h-[90vh] overflow-y-auto scrollable">
          <DialogHeader>
            <DialogTitle className="text-2xl">{t('common.add.performance')}</DialogTitle>
            <DialogDescription>{t('admin.performances.add.dialog.description')}</DialogDescription>
            <p className="mt-1 text-sm text-muted-foreground">
              {t('admin.performances.add.form.required.fields')}
            </p>
          </DialogHeader>
          <div className="mt-6">
            <AddPerformanceForm onSuccess={handleSuccess} fixedCompany={fixedCompany} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
